if (!customElements.get('product-form')) {
  customElements.define('product-form', class AddToCart extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form[action$="/cart/add"]');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
      this.errorAlert = this.querySelector('.product-form__error-message-wrapper');
    }

    formSubmit(evt) {
      evt.preventDefault();
      this.querySelector('button[name="add"]').classList.add('loading');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      config.body = formData;

      const messageField = evt.target.querySelector('#gift_card_message');
      const gift_card_message = messageField ? messageField.value.trim() : '';

      if (gift_card_message !== '') {
        // Спочатку зберігаємо gift_card.message в cart attributes і notes
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'gift_card.message': gift_card_message
            },
            note: gift_card_message // додаємо в notes
          })
        })
            .then(() => {
              // Після оновлення кошика додаємо товар
              return fetch(`${routes.cart_add_url}`, config);
            })
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.errorMessage(response);
                return;
              }
              this.showAddToCartPopup(response);
              this.succses();
            })
            .catch((error) => {
              console.log(error);
            });

      } else {
        // Якщо повідомлення порожнє або поля немає — додаємо товар без змін
        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.errorMessage(response);
                return;
              }
              this.showAddToCartPopup(response);
              // console.log(response);

              this.succses();
            })
            .catch((error) => {
              console.log(error);
            });
      }
    }

    showAddToCartPopup(item) {
      const existingPopup = document.querySelector('.add-to-cart-popup');
      const succsesMessage = document.querySelector('#cart-popup')?.dataset.succsesMessagePopup;
      const delayPopup = document.querySelector('#cart-popup')?.dataset.delayPopup;
      const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[character]);
      if (existingPopup) {
        existingPopup.classList.remove('fade-in');
        existingPopup.classList.add('fade-out');
        setTimeout(() => existingPopup.remove(), 300);
      }

      // const color = item?.properties?.['варіанти шпильки']?.trim();
      let variantDisplayTitles = {};
      const variantDisplayTitlesNode = this.querySelector('[data-variant-display-titles]');
      if (variantDisplayTitlesNode) {
        try {
          variantDisplayTitles = JSON.parse(variantDisplayTitlesNode.textContent);
        } catch (error) {
          console.error('Unable to parse variant display titles.', error);
        }
      }

      const productDisplayTitle = this.dataset.displayProductTitle || item.product_title;
      const variantDisplayTitle = variantDisplayTitles[String(item.variant_id)] || item.variant_title;
      const safeProductDisplayTitle = escapeHtml(productDisplayTitle);
      const safeVariantDisplayTitle = escapeHtml(variantDisplayTitle);
      const safeSuccessMessage = escapeHtml(succsesMessage);
      const safeImageUrl = escapeHtml(item.image);

      let imageUrl = safeImageUrl;
      imageUrl += imageUrl.includes('?') ? '&width=200' : '?width=200';

      let detailsHTML = `<div class="popup-title">${safeProductDisplayTitle}</div>`;
      if (variantDisplayTitle && variantDisplayTitle !== 'Default Title') {
        detailsHTML += `<div class="popup-option">${safeVariantDisplayTitle}</div>`;
      }
      detailsHTML += `<div class="popup-success">${safeSuccessMessage}</div>`;

      const popup = document.createElement('div');
      popup.className = 'added-product-to-cart-popup';

      popup.innerHTML = `
        <button class="popup-close" aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.7938 17.7124L12.0876 12.0062L17.7938 6.3" stroke="#212121" stroke-linejoin="round"/>
            <path d="M6.2062 6.3L11.9124 12.0062L6.2062 17.7124" stroke="#212121" stroke-linejoin="round"/>
          </svg>
        </button>
        <div class="popup-content">
          <img src="${imageUrl}" alt="${safeProductDisplayTitle}" />
          <div class="popup-details">
            ${detailsHTML}
          </div>
        </div>
      `;

      setTimeout(() => {
        popup.classList.add('fade-in');
      }, 10);

      document.body.appendChild(popup);

      popup.querySelector('.popup-close').addEventListener('click', () => {
        popup.classList.remove('fade-in');
        popup.classList.add('fade-out');
        setTimeout(() => popup.remove(), 300);
      });

      popup.querySelector(".popup-content")?.addEventListener("click", event => {
        popup.classList.remove('fade-in');
        popup.classList.add('fade-out');
        setTimeout(() => {
          popup.remove();
          openCartPopup();
        }, 300);
      })


      const escListener = (e) => {
        if (e.key === 'Escape') {
          popup.classList.remove('fade-in');
          popup.classList.add('fade-out');
          setTimeout(() => popup.remove(), 300);
          document.removeEventListener('keydown', escListener);
        }
      };
      document.addEventListener('keydown', escListener);

      setTimeout(() => {
        if (document.body.contains(popup)) {
          popup.classList.remove('fade-in');
          popup.classList.add('fade-out');
          setTimeout(() => popup.remove(), 300);
        }
      }, delayPopup*1000);
    }

    errorMessage(resp) {
      console.log(resp.description);
      if (resp.description.email?.[0] == "Email can't be blank") {
        document.querySelector(".product-form__error-message--send")?.classList.add("d-none");
        document.querySelector(".product-form__error-message--email_invalid")?.classList.add("d-none");

        document.querySelector(".product-form__error-message--email_blank")?.classList.remove("d-none");
      } else if( resp.description.email?.[0] == "Email is invalid") {
        document.querySelector(".product-form__error-message--send")?.classList.add("d-none");
        document.querySelector(".product-form__error-message--email_blank")?.classList.add("d-none");

        document.querySelector(".product-form__error-message--email_invalid")?.classList.remove("d-none");
      } else if( resp.description.send_on?.[0] == "Send on must be within 90 days from now") {
        document.querySelector(".product-form__error-message--email_blank")?.classList.add("d-none");
        document.querySelector(".product-form__error-message--email_invalid")?.classList.add("d-none");

        document.querySelector(".product-form__error-message--send")?.classList.remove("d-none");
      }

      this.errorAlert.classList.remove('d-none');
      this.querySelector('button[name="add"]').classList.remove('loading');
    }

    succses() {
      console.log("Success");
      this.errorAlert.classList.add('d-none');
      this.querySelector('button[name="add"]').classList.remove('loading');
      updateCartBuble();
      // openCartPopup();
      renderCart();
    }
  });
}
